import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from '@steward-app/steward-types';

/**
 * The acceptance line shown beside every button that creates or joins a workspace, and on
 * the intake cover and sign-in card (steward-app#2630). Wording approved by Matt on
 * 2026-10-27. Changing what it says a person agrees to means bumping `TERMS_VERSION`.
 *
 * Notice only: the record is written by {@link recordTermsAcceptance} on the click.
 */
export function TermsAcceptanceLine({
  className = '',
  toneClassName = 'text-slate',
  linkClassName = 'text-bronze-text underline underline-offset-2',
}: {
  className?: string;
  /** The text colour; the intake cover's inverted panel passes its own. */
  toneClassName?: string;
  linkClassName?: string;
}) {
  return (
    <p className={`text-[12px] leading-relaxed font-sans ${toneClassName} ${className}`} data-testid="terms-acceptance-line">
      By continuing, you agree to the Steward{' '}
      <a href={TERMS_OF_SERVICE_URL} target="_blank" rel="noopener noreferrer" className={linkClassName}>Terms of Service</a>
      {' '}and confirm you have read the{' '}
      <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" className={linkClassName}>Privacy Policy</a>.
    </p>
  );
}
